export enum AuthDialogCloseEnum {
  RegisterSuccess = 'registerSuccess',
  LoginSuccess = 'loginSuccess',
}

export enum AuthDialogStepEnum {
  Register = 'register',
  Login = 'login',
  Initial = 'registerOrLogin',
}
